export const SET_SIGNUPBTN = 'SET_SIGNUPBTN';
export const LOADING = 'LOADING';
// export const REGISTER_COMPANY = 'REGISTER_COMPANY';

export const REGISTER_USER = 'REGISTER_USER';
export const REGISTER_USER_SUCCESS = 'REGISTER_USER_SUCCESS';
export const REGISTER_USER_ERROR = 'REGISTER_USER_ERROR';

export const AUTHORIZE_SUCCESS = 'AUTHORIZE_SUCCESS';

export const LOGIN_USER = 'LOGIN_USER';
export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS';
export const LOGIN_USER_ERROR = 'LOGIN_USER_ERROR';

export const LOGOUT_USER = "LOGOUT_USER";
export const LOGOUT_USER_SUCCESS = "LOGOUT_USER_SUCCESS";
export const LOGOUT_USER_ERROR = "LOGOUT_USER_ERROR";

export const REFRESH_USER = "REFRESH_USER";
export const REFRESH_USER_SUCCESS = "REFRESH_USER_SUCCESS";

export const FORGOT_PASSWORD = 'FORGOT_PASSWORD';
export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS';
export const FORGOT_PASSWORD_ERROR = 'FORGOT_PASSWORD_ERROR';

export const RESET_PASSWORD = 'RESET_PASSWORD';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_ERROR = 'RESET_PASSWORD_ERROR';

export const RESEND_VERIFICATION = 'RESEND_VERIFICATION';
export const RESEND_VERIFICATION_SUCCESS = 'RESEND_VERIFICATION_SUCCESS';
export const RESEND_VERIFICATION_ERROR = 'RESEND_VERIFICATION_ERROR';


export const AUTHORIZE_FAIL = 'AUTHORIZE_FAIL';

export const USERS_EMAIL = "USERS_EMAIL";

export const CLEAR_USERS = "CLEAR_USERS";

export const CLEAR_VERIFICATION = "CLEAR_VERIFICATION";